import { useEffect, useState } from 'react';
import { hasNativeCapability, isRunningInBiltNativeShell } from '../utils/nativeShell';

// Match the tablet/desktop build layout. Phone landscape must not enable a kiosk.
const PHONE_BREAKPOINT = '(max-width: 767px)';

function available(): boolean {
  // Old binaries keep their existing contract. Capable shells use measured safe
  // regions; regular phones get the same explicit, scrollable display fallback.
  if (isRunningInBiltNativeShell() || document.documentElement.dataset.biltNativeShell)
    return hasNativeCapability('layoutGeometry');
  return true;
}

/** Entry is intentional. A resize never toggles the selected presentation. */
export function useCarShowAvailable(): boolean {
  const [allowed, setAllowed] = useState(available);
  useEffect(() => {
    const media = window.matchMedia?.(PHONE_BREAKPOINT);
    const update = () => setAllowed(available());
    media?.addEventListener('change', update);
    window.addEventListener('bilt-native-shell-ready', update);
    update();
    return () => {
      media?.removeEventListener('change', update);
      window.removeEventListener('bilt-native-shell-ready', update);
    };
  }, []);
  return allowed;
}
